import Debug from 'debug';

export type QuizStateMachinePhase = 'initial' | 'starting' | 'in-progress' | 'summary' | 'review' |
      'canceled' | 'error'

const debug = Debug('quiz-state-machine-phase-state')

export class QuizStateMachinePhaseState {

  private phase: QuizStateMachinePhase = 'initial'

  updatePhase(phase: QuizStateMachinePhase) {
    debug('updatePhase', phase)
    this.phase = phase
  }

  get isInProgress() {
    return this.phase === 'in-progress'
  }

  get isInSummary() {
    return this.phase === 'summary'
  }

  get isInReview() {
    return this.phase === 'review'
  }
}
